
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import { getOrderTable, postOrderWriteOff } from "@/api/http";
import { column } from "@/assets/types/common";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

type screen = {
    search: string;
    time: Array<string> | null;
    service: Array<number> | null;
};
type screenKey = keyof screen;
type order = {
    ordersn: string;
    create_time: string;
    project: string;
    classifcation: string;
    goodsprice: string;
    user_id: string;
    phone: number | null;
    pay_status_text: string;
    nucleus_pin_code: string;
    nucleus_pin_code_status: number;
    id: number;
};
const columnList: Array<column> = [
    {
        prop: "store_name",
        label: "门店名称",
        width: 180,
    },
    {
        prop: "vip_price",
        label: "卡核销金额（元）",
        width: 164,
    },
    {
        prop: "project_price",
        label: "服务核销金额（元）",
        width: 80,
    },
    {
        prop: "price",
        label: "核销总金额（元）",
        width: 80,
    },
    {
        prop: "price",
        label: "结算给门店金额（元）",
        width: 80,
    },
];
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    // {
    //     name: "待审核",
    //     id: 0,
    // },
    {
        name: "待打款",
        id: 0,
    },
    {
        name: "已打款",
        id: 1,
    },
];
export default defineComponent({
    name: "SettlementMonth",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["每月核销结算"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<order>),
            total = ref(0),
            loading = ref(true),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as screen),
            orderStatus = ref(0),
            screenParameter: any =ref( {
                page: currentPage.value,
                pagesize: pageSize.value,
                status: orderStatusNav[orderStatus.value].id,
                type: 1,
                time: null,
                time_: null,
            } as any),
            project = ref([]),
            dialogFormVisible = ref(false),
            orderDetail = ref({} as order),
            dialogNavIndex = ref(0),
            _upState = (store_id:number, status: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Settlement/settlement',
                    data: {store_id, status}
                }).then((res:any) => {
                    res.status == 202 && getTableData()
                })
            },
            formRef = ref(null);

        let getTableData = () => {

                screenParameter.value.status = orderStatusNav[orderStatus.value].id
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Settlement/list',
                    data: screenParameter.value
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    project.value = res?.content?.project || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            selectChange = (e: any,key: screenKey): void => {
            if (key == 'time'){
                if(e){
                    screenParameter.value.time = ((e as Date).getTime()/1000);
                }else {
                    screenParameter.value.time = '';
                }
            }
                
                getTableData();
            },
            columnChange = (item: order, index: number) => {
               dialogFormVisible.value = true;
               orderDetail.value = item;
                dialogNavIndex.value = index;
            };
        onMounted(() => {
            getTableData();
        });
        watch(orderStatus, (newValue, oldValue) => {
          screenParameter.status = orderStatusNav[newValue].id
            getTableData();
        });
        return {
            headClass,
            columnList,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            orderStatusNav,
            orderStatus,
            screen,
            project,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            formRef,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            columnChange,
            screenParameter,
            _upState
        };
    },
    mounted () {
       
    },
    methods:{
        a () {
            // (this.print as any).click()
            //  (this as any).$print(this.print)
        }
    }
});
